BoardMenuPowerUpSlotTemplate = require 'views/templates/board_menu_power_up_slot'
Controller = require 'controller'
DirectoryPluginItemView = require 'views/directory/directory-plugin-item-view'
PopOver = require 'views/lib/pop-over'
t = require('views/internal/teacup-with-helpers')('board_menu_default')
trackUe = require 'debug/trackUe'

module.exports = class BoardSidebarPowerUpSlotView extends DirectoryPluginItemView
  tagName: 'li'
  className: 'board-menu-navigation-item mod-power-up-slot'

  initialize: ({ @plugin }) ->
    super

  showListingOption: -> true

  events:
    'click': 'toggleOptions'

  navigateToListing: ->
    directoryListingUrl = Controller.getBoardUrl(@model.id, 'power-up', [@plugin.id])
    Controller.navigate directoryListingUrl, { trigger: true }
    PopOver.hide()
    trackUe('power-up slot', 'opens', 'Power-Up directory list page', '', '', 'by clicking view Power-Up', @plugin.id)

  render: ->
    @$el.html BoardMenuPowerUpSlotTemplate.powerUpSlot({
      id: @plugin.id
      name: @plugin.get('name')
      icon: @plugin.get('icon')
    })

    @



// WEBPACK FOOTER //
// ./app/scripts/views/board-menu/board-sidebar-power-up-slot-view.coffee